// extracted by mini-css-extract-plugin
export default {"container":"Editor__container--JkZ57E","header":"Editor__header--iK4dAI","headerContent":"Editor__headerContent--jzmQPV","content":"Editor__content--Bb4YoD"};